var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewCardPurchaseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.75H14M4.4 10.5H7.4M9.2 10.5H9.8M3.2 3H12.8C13.4627 3 14 3.55964 14 4.25V11.75C14 12.4404 13.4627 13 12.8 13H3.2C2.53726 13 2 12.4404 2 11.75V4.25C2 3.55964 2.53726 3 3.2 3Z",
    stroke: "#657386",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewCardPurchaseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new-card-purchase-icon.823c89f6064e54e8aec078e94ff714aa.svg";